var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableNoDataImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 73,
    viewBox: "0 0 72 73",
    width: 72,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36 73c19.8822 0 36-16.3416 36-36.5s-16.1178-36.5-36-36.5c-19.8823 0-36 16.3416-36 36.5s16.1177 36.5 36 36.5z",
    fill: "#e7f0ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m57.6 73h-43.2v-47.2067c2.0362-.0023 3.9883-.8234 5.4281-2.2832s2.2496-3.439 2.2519-5.5034h27.84c-.0021 1.0226.1958 2.0356.5823 2.9802s.9539 1.8022 1.6694 2.523c.7109.7257 1.5568 1.3011 2.4885 1.6931.9318.392 1.931.5926 2.9398.5903z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m36 49.64c6.3623 0 11.52-5.2293 11.52-11.68s-5.1577-11.68-11.52-11.68-11.52 5.2293-11.52 11.68 5.1577 11.68 11.52 11.68z",
    fill: "#3884ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m40.0729 43.4661-4.0729-4.1295-4.0729 4.1295-1.3577-1.3765 4.073-4.1295-4.073-4.1295 1.3577-1.3765 4.0729 4.1295 4.0729-4.1295 1.3577 1.3765-4.073 4.1295 4.073 4.1295z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#e7f0ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m42.2399 52.56h-12.48c-.7952 0-1.44.6537-1.44 1.46s.6448 1.46 1.44 1.46h12.48c.7953 0 1.44-.6537 1.44-1.46s-.6447-1.46-1.44-1.46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.56 58.4h-21.12c-.7953 0-1.44.6537-1.44 1.46s.6447 1.46 1.44 1.46h21.12c.7953 0 1.44-.6537 1.44-1.46s-.6447-1.46-1.44-1.46z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableNoDataImage);
export default __webpack_public_path__ + "static/media/TableNoDataImage.a40cac36207c05031928db8ce27d7535.svg";
export { ForwardRef as ReactComponent };